<template>
  <v-container>
    <v-layout row align-center class="my-3">
      <v-icon color="primary">done_all</v-icon>&nbsp;&nbsp;
      <span v-if="estadoDjbr === 1" class="txt-titulo">Finalizar Llenado de la Declaración</span>
      <span v-if="estadoDjbr !== 1" class="txt-titulo">Finalizar Declaración</span>
      <v-spacer/>
      <card-current-time/>
    </v-layout>
    <!-- Finalizacion -->
    <div v-if="estadoDjbr === 1">
      <!-- <div v-show="!aprobar && finalizar"> -->
      <v-layout row>
        <v-flex md10 sm10 xs10>
          <v-alert
            align="justify"
            :value="true"
            :color="alert1?'success':'warning'"
            outline
          >
            <span class="subheading">¿Usted ha terminado de registrar toda la información solicitada en el Formulario Único de la Declaración Jurada de Bienes y Rentas Digital?</span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert1"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md10 sm10 xs10>
          <v-alert
            align="justify"
            :value="true"
            :color="alert2?'success':'warning'"
            outline
          >
            <span class="subheading">¿Usted ha revisado los datos de su Declaración Jurada y está de acuerdo con el contenido? (En la sección anterior puede imprimir un BORRADOR del Formulario de la Declaración Jurada para revisar su contenido)</span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert2"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md10 sm10 xs10>
          <v-alert
            align="justify"
            :value="true"
            :color="alert3?'success':'warning'"
            outline
          >
            <span class="subheading">¿Está consciente, que una vez finalizada la Declaración Jurada de Bienes y Rentas Digital, NO será posible modificar la información?</span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert3"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex md10 sm10 xs10>
          <v-alert
            align="justify"
            :value="true"
            :color="alert4?'success':'warning'"
            outline
          >
            <span class="subheading">¿Está consciente de las consecuencias legales de registrar información falsa o incompleta en la Declaración Jurada de Bienes y Rentas Digital?</span>
          </v-alert>
        </v-flex>
        <v-flex md2 sm2 xs2 class="ml-4">
          <v-layout align-center justify-end row fill-height>
            <v-switch v-model="alert4"></v-switch>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-end row fill-height>
        <v-btn color="primary" dark @click.stop="abrirDialogoFinalizar()">
          <v-icon>done_all</v-icon>&nbsp;&nbsp;&nbsp;Finalizar Llenado
        </v-btn>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="dialogFinalizar" scrollable persistent max-width="650">
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Finalizar Llenado de la Declaración Jurada de Bienes y Rentas Digital</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn v-if="btnAprobado !== true" icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text align="justify" v-show="alert1 && alert2 && alert3 && alert4">
              <v-alert align="justify" outline small :value="alertAdvertenciaFechaLimite" color="warning">
                <v-icon color="warning">warning</v-icon>
                <span><b class="subheading font-weight-bold warning--text">Advertencia</b><br></span>
                <span class="subheading warning--text">Se está finalizando la declaración en el límite establecido para la recepción.<br>Tome en cuenta que la aprobación y recepción digital podría demorar unos minutos. Continúe bajo su responsabilidad.</span>
              </v-alert>
              <p v-if="btnAprobado === false">
                <strong
                  align="justify">PENÚLTIMO PASO:<br>
                Finalizar EL LLENADO de la Declaración Jurada de Bienes y Rentas Digital</strong><br>
                <v-divider></v-divider>
                <strong
                  align="justify"
                >Esta declaración tendrá plena validez legal ejerciendo CIUDADANÍA DIGITAL</strong>
                <br />
                <br /><b><u>Una vez finalizado el llenado</u></b>,  
                <strong>NO</strong> podrá realizar ninguna modificación a la misma y se le redireccionará automáticamente a Ciudadanía Digital para iniciar el proceso de recepción de su Declaración en la CGE presionando el botón “APROBAR” <a href="https://cloud.contraloria.gob.bo/nextcloud/index.php/s/JPP9wZP7eQj8o9g" target="_blank">(Ver Manual)</a>. 
                <strong>NO</strong> CIERRE LA VENTANA NI ACTUALICE EL NAVEGADOR hasta que el sistema lo redirija nuevamente al Sistema DJBR.<br><br>
                Concluido el proceso recibirá una notificación del correo electrónico <a href="mailto:djbr_notificaciones@correo.contraloria.gob.bo">djbr_notificaciones@correo.contraloria.gob.bo</a> confirmando la 
                recepción de su DJBR.<br><br>

                <strong>¿Confirma usted su intención de FINALIZAR EL LLENADO del Formulario de Declaración Jurada de Bienes y Rentas?</strong>
              </p>
              <p v-if="btnAprobado === true" style="border:0px solid black;">
                <b>Redirigiendo a Ciudadanía Digital...</b><br>
                Presione el botón "APROBAR". <br><br>
                <b>NO</b> cierre la ventana, ni actualice el navegador para que la CGE inicie el proceso de recepción de su declaración y se complete la presentación.
              </p>
            </v-card-text>
            <v-card-text v-show="!alert1 || !alert2 || !alert3 || !alert4">
              <span color="red">
                Para finalizar debe responder afirmativamente a
                <b>todas</b> las condiciones requeridas
              </span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-show="alert1 && alert2 && alert3 && alert4"
                color="primary"
                @click="solicitudAprobacion(true), loader = 'btnAprobado'"
                :loading="btnAprobado"
                :disabled="btnAprobado"
              >
                <v-icon>check</v-icon>&nbsp;Continuar
                <template v-slot:loader>
                  <span>Redirigiendo...</span>
                </template>
              </v-btn>
              <v-btn color="error" v-show="!alert1 || !alert2 || !alert3 || !alert4" :disabled="btnAprobado" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Aceptar</v-btn>
              <v-btn color="error" v-show="alert1 && alert2 && alert3 && alert4" :disabled="btnAprobado" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <!-- </div> -->
    </div>
    <div v-if="estadoDjbr !== 1">
      <v-layout wrap text-xs-center>
        <v-flex xs12 md12 sm12 text-xs-center>
          <p class="primary--text"> 
            Su Declaración Jurada de Bienes y Rentas Digital se finalizó, ahora debe aprobar el Formulario Único de Declaración Jurada de Bienes y Rentas Digital (FUDD) con Ciudadanía Digital, después de la aprobación el sistema recepcionará el Certificado de Declaración Jurada de Bienes y Rentas Digital con Firma Digital.
          </p>
        </v-flex>
      </v-layout>
      <!-- Aprobacion del FUD -->
      <v-layout wrap>
        <v-flex xs12 md2 sm2 text-xs-center>
          <!--  -->
        </v-flex>
        <v-flex xs12 md10 sm10>
          <v-layout wrap>
            <v-flex xs12 md10 sm10 text-xs-left>
              <v-icon v-show="estadoDjbr === 2 && !aprobado">error_outline</v-icon>
              <v-icon color='success' v-show="(estadoDjbr === 3 || estadoDjbr === 2) && aprobado">thumb_up_alt</v-icon>
              <strong :class="estadoDjbr === 2 && !aprobado ? 'primary--text' : ''">Aprobación.- </strong>
            </v-flex>
            <v-flex xs12 md10 sm10 text-xs-center>
              <p :class="estadoDjbr === 2 && !aprobado? 'primary--text' : ''" v-if="!((estadoDjbr === 3 || estadoDjbr === 2) && aprobado)">
                Aprobar el Formulario Único de Declaración Jurada de Bienes y Rentas Digital FUDD
              </p>
              <v-btn
                color="primary"
                @click="solicitudAprobacion(false)"
                :loading="btnAprobado"
                v-if="!((estadoDjbr === 3 || estadoDjbr === 2) && aprobado)">
                <v-icon>verified_user</v-icon>&nbsp;Aprobar con Ciudadanía Digital
                <template v-slot:loaderAprobado>
                  <span>Redirigiendo...</span>
                </template>
              </v-btn>
              <span v-else>
                Su Declaración Jurada fue aprobada correctamente con Ciudadanía Digital.
              </span>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- Recepcion de la DJBRD -->
          <v-layout wrap>
            <v-flex xs12 md2 sm2 text-xs-center>
              <!-- -->
            </v-flex>
            <v-flex xs12 md10 sm10>
              <v-layout wrap>
                <v-flex xs12 md10 sm10 text-xs-left>
                  <v-icon v-show="estadoDjbr === 2 && !aprobado">error_outline</v-icon>
                  <v-icon color='success' v-show="estadoDjbr === 3 && aprobado">thumb_up_alt</v-icon>
                  <strong :class="estadoDjbr === 2 && aprobado ? 'primary--text' : ''">Recepción.- </strong>
                </v-flex>
                <v-flex xs12 md10 sm10 text-xs-center>
                  <v-progress-circular
                    v-show="estadoDjbr===2 && aprobado && !errorAprobacion"
                    color="blue"
                    :indeterminate="estadoDjbr===2 && aprobado && !errorAprobacion"
                  ></v-progress-circular>
                  <p v-if="estadoDjbr===2 && aprobado && !errorAprobacion" class="primary--text">Procediendo a la recepción de la Declaración. Este proceso puede demorar unos minutos por favor espere...</p>
                  <p v-if="estadoDjbr===2 && aprobado && errorAprobacion" class="warning--text">Actualmente tenemos varias solicitudes en curso, por favor vuelva al inicio y verifique el estado de su declaración.
                  <br><v-btn v-on:click="reload()" :loading="loadingIntentar" color="primary"><v-icon>history</v-icon>&nbsp;&nbsp;<strong>volver a intentar o recargar la página</strong></v-btn>
                  </p>
                  <span v-else>
                    <p v-if="(estadoDjbr === 3 && aprobado && !errorAprobacion)">Su Declaración Jurada de Bienes y Rentas fue recepcionada. En unos minutos se enviará a su correo electrónico el enlace para la descarga del certificado y el formulario digital.</p>
                    <p v-if="(estadoDjbr === 3 && aprobado && errorAprobacion)">Ocurrió un inconveniente al realizar la recepción de la declaración digital, por favor intente nuevamente habilitar y aprobar la declaración con Ciudadanía Digital.</p>
                  </span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
      <!-- Descarga de documentos. -->
      <v-layout wrap>
        <v-flex xs12 md2 sm2 text-xs-center>
          <!--  -->
        </v-flex>
        <v-flex xs12 md10 sm10>
          <v-layout wrap>
            <!-- <v-flex v-show="estadoDjbr === 3 && idArchivoDigCert === '' && idArchivoDigForm === '' && ver_archivo === false" xs12 md10 sm10 text-xs-center>
              <p :class="(estadoDjbr === 3 && idArchivoDigCert !== '' && idArchivoDigForm !== '') ? 'primary--text' : 'secondary--text'">Cuando los archivos estén firmados completamente puede descargarlos desde el inicio del sistema.</p>
            </v-flex> -->
            <!-- <v-flex xs12 md10 sm10 text-xs-left>
              <v-icon v-show="estadoDjbr!==3 && idArchivoDigCert === '' && idArchivoDigForm === ''">error_outline</v-icon>
              <v-icon color='success' v-show="estadoDjbr === 3 && idArchivoDigCert !== '' && idArchivoDigForm !== ''">error_outline</v-icon>
              <strong :class="estadoDjbr == 3 && idArchivoDigCert !== '' && idArchivoDigForm !== '' ? 'primary--text' : ''">Descarga.- </strong>
            </v-flex> -->
            <!-- <v-flex xs12 md10 sm10 text-xs-center>
              <v-progress-circular
                v-show="ver_archivo === true"
                color="blue"
                :indeterminate="ver_archivo === true"
              ></v-progress-circular>
              <v-flex v-show="estadoDjbr === 3 && idArchivoDigCert !== '' && idArchivoDigForm !== ''" xs12 md10 sm10 text-xs-center>
                <p :class="(estadoDjbr === 3 && idArchivoDigCert !== '' && idArchivoDigForm !== '') ? 'primary--text' : ''">Descargue su Certificado y Formulario Único de Declaración Jurada de Bienes y Rentas Digital</p>
              </v-flex>
              <v-flex v-show="estadoDjbr === 3 && idArchivoDigCert === '' && idArchivoDigForm === '' && ver_archivo === false" xs12 md10 sm10 text-xs-center>
                <p :class="(estadoDjbr === 3 && idArchivoDigCert !== '' && idArchivoDigForm !== '') ? 'primary--text' : 'secondary--text'">Cuando los archivos estén firmados completamente puede descargarlos desde el inicio del sistema.</p>
              </v-flex>
              <v-flex v-show="estadoDjbr === 3 && idArchivoDigCert === '' && idArchivoDigForm === '' && ver_archivo === true" xs12 md10 sm10 text-xs-center>
                <p :class="(estadoDjbr === 3 && idArchivoDigCert !== '' && idArchivoDigForm !== '') ? 'primary--text' : 'secondary--text'">Se está generando el Certificado de recepción y almacenando con el FUD Digital en nuestro Archivo Digital, este proceso puede demorar unos minutos por favor espere.</p>
              </v-flex>
            </v-flex> -->
          </v-layout>
          <!-- <v-layout wrap>
            <v-flex md5 class="text-xs-center">
              <v-btn class="tamanioBoton" :loading="loadingForm" v-if="this.idArchivoDigCert > '0' || this.idArchivoDigCert > null" color="primary" @click="getArchivoDigital(1)">
                <v-icon right dark>cloud_download</v-icon>&nbsp;Formulario
              </v-btn>
            </v-flex>
            <v-flex md5 class="text-xs-center">
              <v-btn class="tamanioBoton" :loading="loadingCert"  v-if="this.idArchivoDigForm > '0'|| this.idArchivoDigForm > null" color="primary" @click="getArchivoDigital(2)">
                <v-icon right dark>cloud_download</v-icon>&nbsp;Certificado
              </v-btn>
            </v-flex>
          </v-layout> -->
          <br>
          <v-layout align-center row wrap>
            <v-flex md10 class="text-xs-center">
              <v-btn text v-if="this.idArchivoDigForm !== '' || volverAtras === true" color="success darken-1" @click="$router.push('/declaracion')">
                <v-icon right>home</v-icon>&nbsp;Volver al Inicio
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      </div>
    <div class="center">
      <v-progress-circular
        v-show="estadoDjbr===2 && aprobado && !errorAprobacion"
        :indeterminate="estadoDjbr===2 && aprobado && !errorAprobacion"
        :size="70"
        :width="7"
        color="blue">
      </v-progress-circular>
    </div>
    <div :class="{ 'v-content__wrap': estadoDjbr === 2 && aprobado && !errorAprobacion }">
    </div>
    <v-dialog v-model="ciudadaniaDialog" scrollable persistent max-width="600">
      <v-card>
        <v-toolbar dark color="primary" right>
          <v-toolbar-title><h4>Mensaje</h4></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="cancelMensajeCiudadania()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text align='center'>
          <br/><strong align='justify'>CIUDADANÍA DIGITAL</strong><br/>
          <v-icon color="success" :size="40" v-if="this.finalizado === 'true'"> done_all </v-icon><br/>
          <v-icon color="warning" :size="40" v-if="this.finalizado === 'false'"> warning </v-icon><br/>
          {{this.mensaje}}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" :disabled="loading" @click="cancelMensajeCiudadania()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout justify-end wrap v-show="botonAnterior">
        <v-btn color="secondary" @click="$router.push('/borrador')">
          <v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior
        </v-btn>
    </v-layout>
    <v-dialog v-model="dialogRecepcion" persistent max-width="900" >
      <v-card> 
        <v-card-text>
          <v-card-title class="justify-center">
            <h3 class="mt-0" style="color: #01579B;"><strong>ATENCIÓN</strong></h3>
          </v-card-title>
          <hr class="ma-1" color="#34699a">
          <p style="text-align: justify;">
            <b>Procesando la recepción de su declaración jurada digital…</b><br><br>
            Por favor, <b>NO</b> cierre la sesión ni la ventana hasta que el proceso haya finalizado.
          </p>
        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogRecepcion = false">CERRAR</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import Parametricas from '../djbrd/mixins/parametricas';
import Auth from '../admin/auth/mixins/auth.js';
const moment = require('moment');
export default {
  mixins: [ Parametricas, Auth ],
  created () {
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.botonAnterior = false;
          this.estadoDjbr = respuesta.data.cod_estado;
          this.aprobado = true;
          this.$service.get('djbr_registro/obtiene_ids_archivo_digital', {}).then(response => {
            if (response && response.err_existente === 0) {
              this.idArchivoDigForm = response.id_archivo_dig_form;
              this.idArchivoDigCert = response.id_archivo_dig_cert;
              this.hashForm = response.hash_form;
              this.hashCert = response.hash_cert;
              if (this.idArchivoDigForm !== '' && this.hashForm !== '') {
                this.aprobado = true;
              }
            } else {
              this.idArchivoDigForm = '';
              this.idArchivoDigCert = '';
              this.hashForm = '';
              this.hashCert = '';
            }
          }).catch(e => {
            if (e.response.data.error_existente === 1) {
              this.volverAtras = true;
            }
          });
        }
        if (respuesta.data.cod_estado === 1) {
          this.estadoDjbr = respuesta.data.cod_estado;
          this.aprobado = respuesta.data.aprobado_blockchain;
          this.botonAnterior = true;
        }
        if (respuesta.data.cod_estado === 2) {
          if (this.estado && this.finalizado && this.mensaje && this.uuidBlockchain && this.linkVerificacion && this.linkVerificacionUnico && this.transactionCode) {
            this.dialogRecepcion = true;
            this.aprobado = true;
          } else {
            this.aprobado = respuesta.data.aprobado_blockchain;
          }
          this.estadoDjbr = respuesta.data.cod_estado;
          this.botonAnterior = false;
        }
        if (respuesta.data.cod_estado === 2 && this.aprobado && this.estado === '' && this.finalizado === '') {
          this.dialogRecepcion = true;
          this.recepcionDjbr();
        }
      }
    });
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response.error_existente === 1) {
        switch (response.error_mensaje) {
          case 'No se ha detectado una declaración jurada activa':
            break;
          case this.aprobado && '#LA ULTIMA DECLARACION JURADA REALIZADA AUN NO FUE PRESENTADA EN OFICINAS DE LA CONTRALORIA GENERAL DEL ESTADO.' && !this.uuidBlockchain && !this.linkVerificacion && !this.linkVerificacionUnico && !this.transactionCode:
            this.recepcionDjbr();
            break;
          case '#LA ULTIMA DECLARACION JURADA REALIZADA AUN NO FUE PRESENTADA EN OFICINAS DE LA CONTRALORIA GENERAL DEL ESTADO.':
            if (this.aprobado) {
              this.$message['info']('Espere para el proceso de recepción');
            }
            break;
          default:
            this.$message['warning'](response.error_mensaje);
            break;
        }
      }
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
    // this.navBarEmmit();
  },
  mounted () {
    this.obtenerValoresUrl();
  },
  data: () => ({
    ver_archivo: false,
    volverAtras: false,
    idArchivoDigCert: '',
    idArchivoDigForm: '',
    dialogFinalizar: false,
    ciudadaniaDialog: false,
    alert1: false,
    alert2: false,
    alert3: false,
    alert4: false,
    aprobado: false,
    estadoDjbr: -1,
    botonAnterior: false,
    btnAprobado: false,
    loading: false,
    loadingForm: false,
    loadingCert: false,
    loadingIntentar: false,
    estado: '',
    finalizado: '',
    mensaje: '',
    uuidBlockchain: null,
    linkVerificacion: null,
    linkVerificacionUnico: null,
    transactionCode: null,
    conDatos: false,
    alertAdvertenciaFechaLimite: false,
    errorAprobacion: false,
    loaderAprobado: false,
    dialogRecepcion: false
  }),
  methods: {
    descargarArchivoPdf () {
      let urlArchivo = 'archivo_predefinido/tutorial_aprobacion_djbrd';
      let usuario = 'portal';
      let nombreUsuario = 'usuario_portal';
      this.$service.get(`${urlArchivo}/${usuario}/${nombreUsuario}`).then(response => {
        if (response) {
          this.downloadPDF(response.documento, response.nombre);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    solicitudAprobacion (fin) {
      this.btnAprobado = true;
      setTimeout(() => {
        this.$service
        .post(`djbr_registro/finalizar_declaracion`, {})
        .then(response => {
          if (response && response.aprobacion) {
            if (response.aprobacion.finalizado) {
              if (fin) {
                this.$message['success']('El proceso de finalización ha sido correcto.');
              }
              this.loaderAprobado = true;
              this.loading = true;
              this.botonAnterior = false;
              this.navBarEmmit();
              this.dialogFinalizar = false;
              this.loading = false;
              this.finalizar = false;
              if (response.aprobacion.link) {
                setTimeout(() => {
                  this.btnAprobado = false;
                  window.location = response.aprobacion.link;
                }, 2000);
              }
            }
            if (!response.aprobacion.finalizado) {
              this.btnAprobado = false;
              this.volverAtras = true;
              this.$message['info']('SERVICIO DE AGETIC NO DISPONIBLE INTENTE MÁS TARDE');
              if (response.aprobacion.message) {
                this.$message['error'](response.aprobacion.message);
                this.$message['info']('SERVICIO NO DISPONIBLE INTENTE NUEVAMENTE');
              }
              if (response.aprobacion.estadoProceso) {
                this.$message['error'](response.aprobacion.estadoProceso);
                this.$message['info']('SERVICIO NO DISPONIBLE INTENTE MÁS TARDE');
                setTimeout(() => {
                  this.logout();
                }, 2000);
              }
            }
          } else {
            this.$message['warning'](response.aprobacion.error || response.err_mensaje);
          }
        }).catch(e => {
          this.loaderAprobado = false;
          this.btnAprobado = false;
          this.volverAtras = true;
          console.log(e);
          this.btnAprobado = false;
        });
      }, 8000);
    },
    obtenerValoresUrl () {
      let url = new URL(window.location);
      let urlSplit = url.hash;
      urlSplit = urlSplit.split('?');
      let parametroString = urlSplit[1];
      let parametroBusqueda = new URLSearchParams(parametroString);
      window.history.replaceState({}, document.title, '#/transaccion');
      this.estado = parametroBusqueda.get('estado');
      this.finalizado = parametroBusqueda.get('finalizado');
      this.mensaje = parametroBusqueda.get('mensaje');
      this.uuidBlockchain = parametroBusqueda.get('uuidBlockchain');
      this.linkVerificacion = parametroBusqueda.get('linkVerificacion');
      this.linkVerificacionUnico = parametroBusqueda.get('linkVerificacionUnico');
      this.transactionCode = parametroBusqueda.get('transactionCode');
      if (this.mensaje && this.linkVerificacion && this.linkVerificacionUnico) {
        this.conDatos = true;
        this.aprobado = true;
      } else {
        this.aprobado = false;
      }
      if (this.mensaje) {
        switch (this.mensaje) {
          case 'La persona interesada ha rechazado la aprobación del trámite o documento':
            this.ciudadaniaDialog = true;
            this.mensaje = 'Ha rechazado la aprobación de documentos con Ciudadanía Digital puede volver a realizar la aprobación en cualquier momento para completar la recepción de su Declaración Jurada de Bienes y Rentas Digital';
            break;
          case 'Completado':
            this.mensaje = 'Se completo la aprobación del documento con Ciudadanía Digital';
            this.$message[this.finalizado === 'false' ? 'warning' : 'success'](this.mensaje);
            break;
          case this.mensaje.includes('El-servicio-de-orden-cronológico-no-está-disponible-en-este-momento'):
            this.ciudadaniaDialog = true;
            this.mensaje = 'La aprobación de documentos con Ciudadanía Digital no puede registrar aprobaciones en el servicio de orden cronológico en este momento, intentelo más tarde';
            break;
          default:
            this.$message[this.finalizado === 'false' ? 'warning' : 'success'](this.mensaje);
            break;
        }
      }
      // TODO en caso de no recibir la notificacion de aprobacion por AGETIC registrar con esta respuesta.
      if (this.estado && this.finalizado && this.mensaje && this.uuidBlockchain && this.linkVerificacion && this.linkVerificacionUnico && this.transactionCode) {
        this.aprobado = true;
        this.botonAnterior = false;
        setTimeout(() => {
          this.recepcionDjbr();
        }, 2000);
      }

      if (this.estadoDjbr === 2 && !this.estado && !this.finalizado && !this.mensaje && !this.uuidBlockchain && !this.linkVerificacion && !this.linkVerificacionUnico && !this.transactionCode) {
        this.aprobado = false;
        this.volverAtras = true;
        setTimeout(() => {
          this.$message['info']('SERVICIO DE AGETIC NO DISPONIBLE INTENTE MÁS TARDE');
        }, 2000);
      }
    },
    verArchivoDigital () {
      this.$service.get('djbr_registro/obtiene_ids_archivo_digital', {}).then(response => {
        if (response && response.err_existente === 0) {
          this.idArchivoDigForm = response.id_archivo_dig_form;
          this.idArchivoDigCert = response.id_archivo_dig_cert;
          this.hashForm = response.hash_form;
          this.hashCert = response.hash_cert;
          if (this.idArchivoDigForm !== '' && this.hashForm !== '') {
            this.aprobado = true;
          }
          this.ver_archivo = false;
          if (response.id_archivo_dig_form === null) {
            this.idArchivoDigForm = '';
            this.idArchivoDigCert = '';
            this.hashForm = '';
            this.hashCert = '';
            this.volverAtras = true;
          }
        } else {
          this.idArchivoDigForm = '';
          this.idArchivoDigCert = '';
          this.hashForm = '';
          this.hashCert = '';
          this.volverAtras = true;
          this.ver_archivo = false;
        }
      }).catch(e => {
        if (e.response.data.error_existente === 1) {
          this.volverAtras = true;
          this.ver_archivo = false;
        }
      });
    },
    recepcionDjbr () {
      this.$service.post(`djbr_registro/recepcion_digital`, {}).then(response => {
        if (response) {
          if (response.error_existente === 0) {
            this.estadoDjbr = 3;
            this.aprobado = true;
            this.loadingIntentar = false;
            this.ver_archivo = true;
            this.idArchivoDigForm = '';
            this.idArchivoDigCert = '';
            this.hashForm = '';
            this.hashCert = '';
            this.volverAtras = true;
            this.ver_archivo = false;
            this.dialogRecepcion = false;
            // setTimeout(() => {
            // this.verArchivoDigital();
            // }, 30000);
          }
          if (response.error_existente === 1) {
            if (response.errores_proceso.length > 0) {
              this.$message['info']('LA DECLARACIÓN SE HA RECEPCIONADO, PERO NO SE HA REALIZADO LA FIRMA DEBE VOLVER AL INICIO Y ESPERAR A QUE EL SISTEMA LO HAGA AUTOMATICAMENTE');
              this.volverAtras = true;
              this.estadoDjbr = 3;
              this.aprobado = true;
              this.loadingIntentar = false;
              this.dialogRecepcion = false;
            } else {
              if (response.error_codigo === 503) {
                this.$message['info']('SERVICIO FIRMA NO DISPONIBLE, INTENTE MÁS TARDE');
              } else {
                this.$message['error'](response.error_mensaje);
              }
              this.loadingIntentar = false;
              this.dialogRecepcion = false;
            }
          }
        }
      }).catch(e => {
        this.loadingIntentar = false;
        if (e.response.data.error_codigo === 503) {
          this.$message['info']('SERVICIO FIRMA NO DISPONIBLE, INTENTE MÁS TARDE');
        } // else {
          // this.$message['error'](e.response.data.error_mensaje);
        // }
        this.errorAprobacion = true;
        this.$forceUpdate();
        this.dialogRecepcion = false;
      });
      setTimeout(() => {
        if (this.estadoDjbr === 2) {
          this.ver_archivo = false;
          this.volverAtras = true;
          this.errorAprobacion = true;
          this.loadingIntentar = false;
        }
      }, 180000);
    },
    getArchivoDigital (idArchvo) {
      let idArchivoDigital = '0';
      let hash = '';
      if (idArchvo === 1) {
        this.loadingForm = true;
        idArchivoDigital = this.idArchivoDigForm;
        hash = this.hashForm;
      }
      if (idArchvo === 2) {
        this.loadingCert = true;
        idArchivoDigital = this.idArchivoDigCert;
        hash = this.hashCert;
      }
      this.$service.get(`djbr_registro/obtiene_certificado_archivo/${idArchivoDigital}/${hash}`, {}).then(response => {
        if (response) {
          const archivo = response.documento;
          const nombre = idArchvo === 2 ? 'CERTIFICADO' : 'FORMULARIO';
          this.downloadPDF(archivo, nombre);
          this.loadingForm = false;
          this.loadingCert = false;
        }
      }).catch(error => {
        console.log(error);
        this.loadingForm = false;
        this.loadingCert = false;
      });
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(this.b64toBlob(pdf, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}_${this.$storage.get('user').nro_documento}.pdf`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },
    cancel () {
      this.loading = false;
      this.btnAprobado = false;
      this.dialogFinalizar = false;
    },
    cancelMensajeCiudadania () {
      this.ciudadaniaDialog = false;
      this.mensaje = '';
    },
    abrirDialogoFinalizar () {
      this.dialogFinalizar = true;
      this.verificaFechaLimite();
    },
    verificaFechaLimite () {
      this.$service.get('fecha_hora_actual', {}).then(response => {
        let horaActual = moment(response.now);
        let ultimoDiaDelmes = (moment(horaActual).endOf('month')).format('DD');
        let diaActual = moment(horaActual).format('DD');
        if (diaActual === ultimoDiaDelmes) {
          let pm = horaActual.format('a') === 'pm';
          if (horaActual.format('hh') === '11' && parseInt(horaActual.format('mm')) > 45 && pm) {
            this.alertAdvertenciaFechaLimite = true;
          }
        } else {
          this.alertAdvertenciaFechaLimite = false;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    reload () {
      this.loadingIntentar = true;
      if (this.aprobado === false) {
        this.$store.commit('setMain', false);
        this.$nextTick(function () {
          this.$store.commit('setMain', true);
        });
        this.loadingIntentar = false;
      } else {
        this.recepcionDjbr();
      }
    }
  }
};
</script>
<style>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Ajusta según sea necesario */
}
</style>



// WEBPACK FOOTER //
// src/components/declaracion/finalizarCiudadaniaSinArchivo.vue